module.exports = __webpack_public_path__ + "img/nutrilon-pepti.0461af7a.png";